<template>
  <div>

    <div class="drug_block" v-for="(drug, index) in drugs">
      <div class="drug_select_div">
        <drugSearch
          :drugSelected="drugs"
        />
      </div>
    </div>

    {{drugs}}
  </div>
</template>

<script>

  import api from '@/api'
  import drugSearch from "../drugs/drugSearch";

  export default {
    components: {
      drugSearch
    },
    props: ['drugs']
  }

</script>
